export default "__VITE_ASSET__7643f75f__"